"use strict";
/**
 * Course domain model
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseHelpers = void 0;
/**
 * Helper functions to check course type
 */
exports.CourseHelpers = {
    isLOA: (course) => course.code === 'LOA',
    isElective: (course) => { var _a; return ((_a = course.code) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('elective')) || false; },
    isInactive: (course) => { var _a; return ((_a = course.code) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('inactive')) || false; },
    isRepeatable: (course) => course.repeatable === true,
    /** Returns true for LOA, Elective, Inactive, or Repeatable courses (can be added to multiple terms) */
    isSpecial: (course) => exports.CourseHelpers.isLOA(course) ||
        exports.CourseHelpers.isElective(course) ||
        exports.CourseHelpers.isInactive(course) ||
        exports.CourseHelpers.isRepeatable(course),
    /** Display label matching legacy: "{displayCode} - {displayName}" */
    getDisplayLabel: (course) => {
        const code = course.displayCode || course.code;
        const name = course.displayName || course.name || code;
        return `${code} - ${name}`;
    },
};
